import React, { useState } from "react";
import VotersChart from "./InActiveVotersChart";

const votersDataByYear = {
  2016: [
    { Fields: "Constitution", "No. of Voters": "682" },
    { Fields: "Democratic", "No. of Voters": "19007" },
    //  { Fields: "Green", "No. of Voters": "176" },
    { Fields: "Independent American", "No. of Voters": "1401" },
    { Fields: "Libertarian", "No. of Voters": "1646" },
    // { Fields: "No Labels", "No. of Voters": "309" },
    { Fields: "Republican", "No. of Voters": "52276" },
    // { Fields: "United Utah", "No. of Voters": "28" },
    // { Fields: "Utah Forward", "No. of Voters": "2" },
    { Fields: "Unaffiliated", "No. of Voters": "92016" },
    { Fields: "Total Inactive Voters", "No. of Voters": " 1,67,028" },
  ],
  2017: [
    { Fields: "Constitution", "No. of Voters": "717" },
    { Fields: "Democratic", "No. of Voters": "19184" },
    { Fields: "Green", "No. of Voters": "176" },
    { Fields: "Independent American", "No. of Voters": "1431" },
    { Fields: "Libertarian", "No. of Voters": "1722" },
    // { Fields: "No Labels", "No. of Voters": "309" },
    { Fields: "Republican", "No. of Voters": "54226" },
    //{ Fields: "United Utah", "No. of Voters": "28" },
    // { Fields: "Utah Forward", "No. of Voters": "2" },
    { Fields: "Unaffiliated", "No. of Voters": "106528" },
    { Fields: "Total Inactive Voters", "No. of Voters": " 1,70,656 " },
  ],
  2018: [
    { Fields: "Constitution", "No. of Voters": "1132" },
    { Fields: "Democratic", "No. of Voters": "23142" },
    { Fields: "Green", "No. of Voters": "176" },
    { Fields: "Independent American", "No. of Voters": "3742" },
    { Fields: "Libertarian", "No. of Voters": "2741" },
    // { Fields: "No Labels", "No. of Voters": "309" },
    { Fields: "Republican", "No. of Voters": "81105" },
    { Fields: "United Utah", "No. of Voters": "28" },
    // { Fields: "Utah Forward", "No. of Voters": "2" },
    { Fields: "Unaffiliated", "No. of Voters": "106528" },
    { Fields: "Total Inactive Voters", "No. of Voters": " 2,18,594 " },
  ],
  2019: [
    { Fields: "Constitution", "No. of Voters": "1263" },
    { Fields: "Democratic", "No. of Voters": "29177" },
    { Fields: "Green", "No. of Voters": "310" },
    { Fields: "Independent American", "No. of Voters": "6942" },
    { Fields: "Libertarian", "No. of Voters": "3681" },
    //  { Fields: "No Labels", "No. of Voters": "309" },
    { Fields: "Republican", "No. of Voters": "87261" },
    { Fields: "United Utah", "No. of Voters": "159" },
    //{ Fields: "Utah Forward", "No. of Voters": "2" },
    { Fields: "Unaffiliated", "No. of Voters": "112275" },
    { Fields: "Total Inactive Voters", "No. of Voters": " 2,41,068 " },
  ],
  2020: [
    { Fields: "Constitution", "No. of Voters": "1258" },
    { Fields: "Democratic", "No. of Voters": "29078" },
    { Fields: "Green", "No. of Voters": "310" },
    { Fields: "Independent American", "No. of Voters": "6921" },
    { Fields: "Libertarian", "No. of Voters": "3669" },
    // { Fields: "No Labels", "No. of Voters": "309" },
    { Fields: "Republican", "No. of Voters": "86846" },
    { Fields: "United Utah", "No. of Voters": "159" },
    //{ Fields: "Utah Forward", "No. of Voters": "2" },
    { Fields: "Unaffiliated", "No. of Voters": "112055" },
    { Fields: "Total Inactive Voters", "No. of Voters": "240296" },
  ],
  2021: [
    { Fields: "Constitution", "No. of Voters": "1069" },
    { Fields: "Democratic", "No. of Voters": "28354" },
    // { Fields: "Green", "No. of Voters": "15" },
    { Fields: "Independent American", "No. of Voters": "9076" },
    { Fields: "Libertarian", "No. of Voters": "3550" },
    //{ Fields: "No Labels", "No. of Voters": "309" },
    { Fields: "Republican", "No. of Voters": "64934" },
    { Fields: "United Utah", "No. of Voters": "314" },
    // { Fields: "Utah Forward", "No. of Voters": "2" },
    { Fields: "Unaffiliated", "No. of Voters": "77340" },
    { Fields: "Total Inactive Voters", "No. of Voters": "184637" },
  ],
  2022: [
    { Fields: "Constitution", "No. of Voters": "1255" },
    { Fields: "Democratic", "No. of Voters": "35108" },
    // { Fields: "Green", "No. of Voters": "15" },
    { Fields: "Independent American", "No. of Voters": "11357" },
    { Fields: "Libertarian", "No. of Voters": "4220" },
    //{ Fields: "No Labels", "No. of Voters": "309" },
    { Fields: "Republican", "No. of Voters": "79864" },
    { Fields: "United Utah", "No. of Voters": "392" },
    //{ Fields: "Utah Forward", "No. of Voters": "2" },
    { Fields: "Unaffiliated", "No. of Voters": "87171" },
    { Fields: "Total Inactive Voters", "No. of Voters": "219367" },
  ],
  2023: [
    { Fields: "Constitution", "No. of Voters": "1494" },
    { Fields: "Democratic", "No. of Voters": "42251" },
    // { Fields: "Green", "No. of Voters": "15" },
    { Fields: "Independent American", "No. of Voters": "14976" },
    { Fields: "Libertarian", "No. of Voters": "5373" },
    { Fields: "No Labels", "No. of Voters": "19" },
    { Fields: "Republican", "No. of Voters": "89118" },
    { Fields: "United Utah", "No. of Voters": "655" },
    // { Fields: "Utah Forward", "No. of Voters": "2" },
    { Fields: "Unaffiliated", "No. of Voters": "103075" },
    { Fields: "Total Inactive Voters", "No. of Voters": "256961" },
  ],
  2024: [
    { Fields: "Constitution", "No. of Voters": "1495" },
    { Fields: "Democratic", "No. of Voters": "38131" },
    { Fields: "Green", "No. of Voters": "10" },
    { Fields: "Independent American", "No. of Voters": "15004" },
    { Fields: "Libertarian", "No. of Voters": "5103" },
    { Fields: "No Labels", "No. of Voters": "220" },
    { Fields: "Republican", "No. of Voters": "84719" },
    { Fields: "United Utah", "No. of Voters": "754" },
    { Fields: "Utah Forward", "No. of Voters": "0" },
    { Fields: "Unaffiliated", "No. of Voters": "102919" },
    { Fields: "Total Inactive Voters", "No. of Voters": "248355" },
  ],
  2025: [
    { Fields: "Constitution", "No. of Voters": "1,644" },
    { Fields: "Democratic", "No. of Voters": "42,746" },
    { Fields: "Green", "No. of Voters": "51" },
    { Fields: "Independent American", "No. of Voters": "17,007" },
    { Fields: "Libertarian", "No. of Voters": "5,634" },
    { Fields: "No Labels", "No. of Voters": "642" },
    { Fields: "Republican", "No. of Voters": "97,987" },
    { Fields: "Utah Forward", "No. of Voters": "810" },
    { Fields: "Unaffiliated", "No. of Voters": "1,12,931" },
    { Fields: "Total Inactive Voters", "No. of Voters": "2,79,452" },
  ],
};

const InActiveVoters = () => {
  const [selectedYear, setSelectedYear] = useState("2025");

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          width: "96%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h1 style={{ color: "#CB0C0C", marginBottom: "20px" }}>
          Inactive Voters Chart - {selectedYear}
        </h1>

        {/* Year Dropdown */}
        <select
          onChange={handleYearChange}
          value={selectedYear}
          style={{
            marginBottom: "20px",
            padding: "10px",
            fontSize: "16px",
          }}
        >
          {Object.keys(votersDataByYear).map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
      <div style={{ width: "100%", overflowX: "auto" }}>
        <div style={{ width: "100%", minWidth: "600px" }}>
          <VotersChart data={votersDataByYear[selectedYear]} />
        </div>
      </div>
    </div>
  );
};

export default InActiveVoters;
